import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { Collapse } from 'react-collapse';
import { useContentfulSelector } from '../../../redux/hooks';
import { selectPageComponentById } from '../../../redux/selectors';
import { ItemBody, ItemContent, ItemHeader, ItemWrapper } from './styles';
const ScrollingBannerItem = ({ isActive, handleItemClick, handleMouseItemEnter, handleMouseItemLeave, entryId, }) => {
    const item = useContentfulSelector((state) => selectPageComponentById(state, entryId));
    const handleClick = () => {
        handleItemClick(entryId);
    };
    if (!item)
        return null;
    return (_jsx(ItemWrapper, { onClick: handleClick, "$isActive": isActive, onMouseEnter: handleMouseItemEnter, onMouseLeave: handleMouseItemLeave, children: _jsxs(ItemContent, { children: [_jsx(ItemHeader, { children: _jsx(Typography.Title, { level: 3, elementTheme: "subtitle2", children: item.fields.title }) }), _jsx(Collapse, { isOpened: !!isActive, children: _jsx(ItemBody, { children: _jsx(Typography, { elementTheme: "body2", children: item.fields.body }) }) })] }) }));
};
export default ScrollingBannerItem;
